/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'ico-you': {
    width: 22,
    height: 15,
    viewBox: '0 0 22 15',
    data: `<path pid="0" d="M9.111 14.981c-4.19-.075-5.62-.142-6.5-.318-.595-.117-1.112-.376-1.491-.753-.294-.285-.527-.72-.707-1.322-.155-.503-.216-.92-.302-1.942-.132-2.305-.163-4.189 0-6.294.135-1.163.2-2.543 1.095-3.348.422-.377.914-.62 1.465-.72C3.533.127 7.206 0 11.008 0c3.794 0 7.474.126 8.337.285.69.125 1.336.502 1.716.987.816 1.247.83 2.797.913 4.01.035.577.035 3.857 0 4.435-.129 1.916-.232 2.595-.525 3.297-.182.444-.336.678-.604.938-.42.4-.955.665-1.535.761-3.625.265-6.704.323-10.199.268zm5.553-7.7c-2.018-1.046-3.949-2.016-5.923-3.02v6.009c2.077-1.097 4.268-2.101 5.931-2.997l-.008.008z"/>`
  }
})
